import React from 'react'
import {Field, reduxForm, formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronLeft, faRedo, faPlus } from '@fortawesome/free-solid-svg-icons'
import {APP_MODE_QA} from '../app/AppConstants';
import SubformsContainer from "./subforms/SubformsContainer";


let OrderForm = props => {
  const {handleSubmit, reset, customReset, submitting, skip, onPrevious, mode, onCreateCustomer, onCreatePersona, onCreateBillingAddress,
    onCreateShippingAddress, transactionTypes,
    addCustomerValue, addPersonaValue, addBillingAddressValue, addShippingAddressValue, paymentDetailsValue} = props;

  const onReset = () => {
    customReset();
    reset();
  };

  const getCustomerFields = () => {
    return <div className="row">
      <div className="col-xs-12">
        <div className="form-group">
          <div className="row">
            <div className="col-xs-12">
              <div className="checkbox">
                <label>
                  <Field name="addCustomer" component="input" type="checkbox" /> <b>Add Customer</b>
                </label>
              </div>
              {addCustomerValue && <div className="row">
                <div className="col-lg-6 col-xs-12">
                  <Field className="form-control" name="customer" component="input" type="text" />
                </div>
                <div className="col-lg-6 col-xs-12">
                  <button className="btn btn-primary" type="button" onClick={onCreateCustomer}>
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
      {addCustomerValue && <div className="col-xs-12">
        <div className="form-group">
          <div className="row">
            <div className="col-xs-12">
              <div className="checkbox">
                <label>
                  <Field name="addPersona" component="input" type="checkbox" /> <b>Add Persona</b>
                </label>
              </div>
              {addPersonaValue && <div className="row">
              <div className="col-lg-6 col-xs-12">
                <Field className="form-control" name="persona" component="input" type="text"/>
              </div>
              <div className="col-lg-6 col-xs-12">
                <button className="btn btn-primary" type="button" onClick={onCreatePersona}>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
                </div>
              </div>}
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-xs-12">
              <div className="checkbox">
                <label>
                  <Field name="addBillingAddress" component="input" type="checkbox" /> <b>Add Billing Address</b>
                </label>
              </div>
              {addBillingAddressValue && <div className="row">
                <div className="col-lg-6 col-xs-12">
                  <Field className="form-control" name="billingAddress" component="input" type="text"/>
                </div>
                <div className="col-lg-6 col-xs-12">
                  <button className="btn btn-primary" type="button" onClick={onCreateBillingAddress}>
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>}
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="row">
            <div className="col-xs-12">
              <div className="checkbox">
                <label>
                  <Field name="addShippingAddress" component="input" type="checkbox" /> <b>Add Shipping Address</b>
                </label>
              </div>
              {addShippingAddressValue && <div className="row">
                <div className="col-lg-6 col-xs-12">
                  <Field className="form-control" name="shippingAddress" component="input" type="text"/>
                </div>
                <div className="col-lg-6 col-xs-12">
                  <button className="btn btn-primary" type="button" onClick={onCreateShippingAddress}>
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>}
    </div>;
  };

  return (
    <div>
      <div>
        <SubformsContainer/>
      </div>
      <h3>Create Order Form</h3>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="form-group col-sm-6">
            <label htmlFor="amount">Amount (in cents)</label>
            <Field className="form-control" name="amount" component="input" type="number"/>
          </div>
          <div className="form-group col-sm-6">
            <label htmlFor="currency">Currency</label>
            <Field className="form-control" name="currency" component="input" type="text"/>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="transactionType">Type</label>
          <Field className="form-control" component="select" name="transactionType">
            {transactionTypes.map(option => {
              return (
                <option
                  key={option}
                  value={option}
                  label={option}>{option}
                </option>
              );
            })}
          </Field>
        </div>
        <div className="form-group">
          <label htmlFor="allowedProducts">
            Allowed Products (comma "," separated). Leave empty for all products <br />
            <small>Options: 'creditcard', 'paypal','ratepay-invoice', 'ratepay-directdebit', 'ratepay-installment', 'sofort', 'ideal', 'klarna', 'alipay', 'bancontact', 'wechat-pay', 'postfinance-card', 'payu',
              'paysafecard', 'applepay', 'twint', 'union-pay'</small>
          </label>
          <Field className="form-control" name="allowedProducts" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="async.successUrl">Success URL</label>
          <Field className="form-control" name="async.successUrl" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="async.failureUrl">Failure URL</label>
          <Field className="form-control" name="async.failureUrl" component="input" type="text"/>
        </div>
        <div className="form-group">
          <label htmlFor="async.cancelUrl">Cancel URL</label>
          <Field className="form-control" name="async.cancelUrl" component="input" type="text"/>
        </div>
        <div>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field name="paymentDetailsUsage.confirmUrl" component="input" type="checkbox"/> <b>Confirm URL</b>
              </label>
            </div>
          </div>
          {paymentDetailsValue && paymentDetailsValue.confirmUrl && <div>
            <div className="form-group">
              <label htmlFor="async.confirmUrl">Confirm URL (*This field is mandatory for Button Widget)</label>
              <Field className="form-control" name="async.confirmUrl" component="input" type="text"/>
            </div>
          </div>}
        </div>
        <div className="form-group">
          <label htmlFor="ipAddress">IP Address (*This field is mandatory for RatePAY orders)</label>
          <Field className="form-control" name="ipAddress" component="input" type="text"/>
        </div>
        <div className="form-group">
          <div className="checkbox">
            <label>
              <Field name="addBasket" component="input" type="checkbox" /> <b>Add Basket</b>
            </label>
          </div>
        </div>
        {getCustomerFields()}
        <div className="hr-line-dashed"></div>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-lg-3 col-md-3 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={onPrevious} disabled={mode !== APP_MODE_QA}>
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className="btn-text">Previous</span>
              </button>
            </div>
            <div className="col-lg-3 col-md-3 col-xs-12 text-center m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" disabled={submitting} onClick={onReset}>
                <FontAwesomeIcon icon={faRedo} />
                <span className="btn-text">Reset</span>
              </button>
            </div>
            <div className="col-lg-3 col-md-3 col-xs-12 m-b-xs">
              <button type="submit" className="btn btn-primary col-xs-12" disabled={submitting}>
                <span className="btn-text">Next</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
            <div className="col-lg-3 col-md-3 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-default col-xs-12" onClick={skip}>
                <span className="btn-text">Skip</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

OrderForm = reduxForm({
  form: 'order',
  enableReinitialize: true
})(OrderForm);

const selector = formValueSelector('order');

OrderForm = connect(
  (state) => {
    const initialValues = {
      ...state.order.orderForm,
      paymentDetailsUsage: {
        confirmUrl: true
      },
    };

    return {
      initialValues,
      addCustomerValue: selector(state, 'addCustomer'),
      addPersonaValue: selector(state, 'addPersona'),
      addBillingAddressValue: selector(state, 'addBillingAddress'),
      addShippingAddressValue: selector(state, 'addShippingAddress'),
      paymentDetailsValue: selector(state, 'paymentDetailsUsage')
    };
  }
)(OrderForm);

export default OrderForm;



// WEBPACK FOOTER //
// ./src/order/OrderForm.js